import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface AppState {
  tenantSelectorVisible: boolean;
  tenantCreatorVisible: boolean;
}

const initialState: AppState = {
  tenantSelectorVisible: false,
  tenantCreatorVisible: false,
};

const AppSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleTenantSelector: (state, action: PayloadAction<boolean>) => {
      state.tenantSelectorVisible = action.payload;
    },
    toggleTenantCreator: (state) => {
      state.tenantCreatorVisible = !state.tenantCreatorVisible;
    },
  },
});

export const { toggleTenantSelector, toggleTenantCreator } = AppSlice.actions;
export default AppSlice.reducer;
